import { FC, useCallback, useEffect, useRef, useState } from 'react';

import CheckboxComponent from './CheckboxComponent';

import IconComponent from '../IconComponent';

import { ICONS } from '../../utils/enum/Icons';

interface Props {
    options: MultiSelectOption[];
    selectedValues: MultiSelectOption[] | null;
    onChange: (option: MultiSelectOption[]) => void;
    label?: string;
    placeholder?: string;
}

export interface MultiSelectOption {
    id: number | string;
    checked: boolean;
    value: number | string;
    label: string;
}

const MultiSelectComponent: FC<Props> = ({ options, selectedValues, onChange, label, placeholder }) => {
    const ref = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [optionCheckedCounter, setOptionCheckedCounter] = useState(0);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (ref.current && !(ref.current as HTMLElement).contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isOpen]);

    const resetFilters = useCallback(() => {
        const updatedOptions = options.map((option: MultiSelectOption) => {
            option.checked = false;
            return option;
        });
        setOptionCheckedCounter(0);

        onChange(updatedOptions);
    }, [options]);

    return (
        <div className="br-multiSelect" ref={ref}>
            {label ? <label>{label}</label> : null}
            <div className={`br-multiSelect__wrapper ${isOpen ? '-open' : ''}`}>
                <div className="br-multiSelect__button" onClick={() => setIsOpen(!isOpen)}>
                    {/* <span>{selectedValues ? selectedValues[0]?.label : ''}</span> */}
                    <span>{placeholder}</span>
                    <div className="arrow">
                        <IconComponent icon={ICONS.chevron_down} />
                    </div>
                </div>
                <div className="br-multiSelect__dropdown">
                    <div className="br-multiSelect__dropdownHead">
                        <span className="br-multiSelect__dropdownHeadCounter">{optionCheckedCounter} Selezionati</span>
                        <span className="br-multiSelect__dropdownHeadAction" onClick={resetFilters}>
                            Reset
                        </span>
                    </div>
                    <div className="br-multiSelect__dropdownContent">
                        {options.map((option: MultiSelectOption) => {
                            return (
                                <span key={option.value} className="br-multiSelect__option" data-value={option.value}>
                                    <CheckboxComponent
                                        checked={option.checked}
                                        onChange={(checked: boolean) => {
                                            option.checked = checked;
                                            if (checked) {
                                                setOptionCheckedCounter(optionCheckedCounter + 1);
                                            } else {
                                                setOptionCheckedCounter(optionCheckedCounter - 1);
                                            }

                                            onChange(options);
                                        }}
                                    ></CheckboxComponent>
                                    {option.label}
                                </span>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MultiSelectComponent;
